import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  thinBorder: {
    border: 'solid 1px #000',
    padding: '1px',
  },
  thinBorderFour: {
    border: 'dashed 1px #999',
    borderRadius: '5%',
    width: '500px',
    padding: '10px',
    backgroundColor: '#fff',
  },
  innerInnerBorder: {
    border: `dotted 3px ${theme.custom.secondary}`,
  },
  innerInnerInnerBorder: {
    border: `dotted 3px ${theme.custom.secondary}`,
  },
  innerInnerSmallBorder: {
    border: `dotted 2px ${theme.custom.secondary}`,
    padding: '2px',
  },
  innerMostThinBorderTwo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    border: 'solid 1px #999',
    padding: '10px',
    backgroundColor: '#fff',
  },
}));

const WalletCardBorder = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.thinBorderFour}>
      <div className={classes.thinBorder}>
        <div className={classes.innerInnerBorder}>
          <div className={classes.innerInnerInnerBorder}>
            <div className={classes.innerInnerSmallBorder}>
              <div className={classes.innerInnerSmallInnerBorder}>
                <div className={classes.innerMostThinBorder}>
                  <div className={classes.innerMostThinBorderTwo}>
                    {children}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletCardBorder;
